<template>
    <el-dialog :visible.sync="$store.state.loginDialogState" top="25vh" width="500px" :before-close="beforeClose">
        <div class="login-data-menu">
            <div class="login-title-menu">
                <div class="login-title">欢迎登录</div>
                <div class="login-tip">智能云算力资源交易平台</div>
            </div>
        </div>
        <!-- tab 切换 -->
        <div class="login-data-signup"></div>
        <!-- 登录 -->
        <div  class="login-data-entry">
            <el-form ref="login-form" :model="formData" :rules="rules">
                <el-form-item prop="loginName">
                    <el-input v-model.trim="formData.loginName" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item prop="passWord">
                    <el-input v-model.trim="formData.passWord" :type="isViewPassword?'password':'text'" placeholder="请输入密码">
                        <el-button slot="append" icon="el-icon-view" @click="isViewPassword = !isViewPassword"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <button class="login-btn" @click="handleClickLoginUser">登 录</button>
                </el-form-item>
                <el-form-item>
                    
                    <div class="login-register">还没账号？<span @click="handleClickRegister">去注册</span></div>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
import {
    login
} from '@/api/index'
export default {
    data() {
        return {
            isViewPassword: true,
            formData: {
                loginName: '',
                passWord: '',
            },
            rules: {
                loginName: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                passWord: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        // 登录
        handleClickLoginUser() {
            this.$refs['login-form'].validate(valid => {
                if (valid) {
                    let paramObj = {
                        account:this.formData.loginName,
                        password:this.formData.passWord,
                    }
                    login(paramObj).then(res=>{
                        if(res.data.flag){
                            //token
                            sessionStorage.setItem('cloud_login_token', res.data.token);
                            //username
                            sessionStorage.setItem('cloud_login_name', res.data.user);
                            // /1个人需求 2公司需求 3资源 4渠道
                            sessionStorage.setItem('cloud_login_user_role',res.data.role);
                            //本地存储 更新header栏 显示状态
                            this.$store.commit('SET_TOKEN',  res.data.token);
                            //清空表单验证
                            this.$refs['login-form'].resetFields();
                            //关闭弹窗
                            this.$store.commit('SET_LOGIN_DIALOG_STATE', false);
                        }else {
                            this.$message.error('用户名或密码错误,请重新输入');
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 去注册
        handleClickRegister(){
            this.$store.commit('SET_LOGIN_DIALOG_STATE', false); //关闭当前登录弹窗
            this.$store.commit('SET_REGISTER_DIALOG_STATE', true); //打开注册弹窗
            
        }, 
        beforeClose(){
            this.$store.commit('SET_LOGIN_DIALOG_STATE', false); //关闭当前登录弹窗
            this.$refs['login-form'].resetFields();
        },
    },
};
</script>

<style lang="scss" scoped>
.login-data-menu {
    width:100%;
    height:auto;
    cursor:default;
    color:#000;
    .login-title-menu{
        text-align:center;
        .login-title{
            font-size:1.5rem;
            font-weight:600;
            // color:#000;
        }
        .login-tip{
            font-size:1.25rem;
            margin-top:10px;
        }
    }
}
.login-data-signup{
    width:400px;
    // height:40px;
    margin:20px auto 0;
    cursor:default;
    border-bottom:2px solid #e5e7eb;
}
.login-data-entry{
    width: 400px;
    height: auto;
    margin: 20px auto 0;
    .login-btn{
        width:100%;
        height:40px;
        border:0;
        outline:none;
        color:#fff;
        border-radius:5px;
        background-color:#0066ff;
        cursor:pointer;
    }
}
.login-register{
    cursor:default;
    text-align:right;
    span{
        color:#0066ff;
        cursor:pointer;
    }
}
</style>
